module.exports = __webpack_public_path__ + "img/logo-tpm.7cd6725f.png";